import Smartphones from 'Events/BankTransfer/views/BankTransferFormView/containers/Smartphones'
import Tablets from 'Events/BankTransfer/views/BankTransferFormView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const BankTransferView = getCurrentDeviceView(Smartphones, Tablets)

export default BankTransferView
